module.exports = __webpack_public_path__ + "img/profile1.8e978b3d.png";